import { useState } from 'react';
import axios from '../config/axiosConfig'; // Adjust the import path as necessary
import getCookie from '../utils/utils'; // Adjust the import path as necessary

function useDeleteItem() {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const deleteItem = async (submitUrl) => {
        setIsLoading(true);
        setError(null);

        try {
            const token = getCookie('JWT_COOKIE_MUSIC_ONLINE'); // Use your method to get the auth token
            await axios.delete(submitUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            setIsLoading(false);
            // Optionally, you can return something here if needed, e.g., a success status
        } catch (error) {
            console.error('Error deleting item:', error);
            setError(error);
            setIsLoading(false);
            // Optionally, throw the error if you want to handle it outside the hook
            throw error;
        }
    };

    return { deleteItem, isLoading, error };
}

export default useDeleteItem;
